import { CumulativeTimeAndIntensityDTO } from '@/api/core/dto/snapshot/TimeStepCumulativeRainfallDTO'
import { CumulativeRainfallIntensity } from './CumulativeRainfallIntensity'

export class CumulativeRainfallIntensityFactory {
  static fromDTO(dto: CumulativeTimeAndIntensityDTO): CumulativeRainfallIntensity {
    return new CumulativeRainfallIntensity(dto.cumulativeRainfall, dto.maxIntensity)
  }
}
